export default __webpack_public_path__ + "static/media/setupcollateral_loanwatch.6d151b30.svg";